import React, { useEffect, useRef } from 'react';

const LANES = [
  ['frequency', 'Intonazione (Hz)', 70, 300, '#fbbf24'],
  ['voiceness', 'Sonorità', 0, 1, '#f472b6'],
  ['intensity', 'Intensità', 0, 1, '#a78bfa'],
  ['tongueIndex', 'Lingua · avanti/dietro', 10, 35, '#22d3ee'],
  ['tongueDiameter', 'Lingua · alta/bassa', 1.5, 3.5, '#38bdf8'],
  ['constrictionIndex', 'Punta · posizione', 22, 39, '#34d399'],
  ['constrictionDiameter', 'Punta · chiusura', -2, 3, '#4ade80'],
  ['lipDiameter', 'Labbra · apertura', 0, 3, '#fb7185'],
];

export const TrajectoryChart = ({ response, frac }) => {
  const ref = useRef(null);
  useEffect(() => {
    const cv = ref.current; if (!cv) return;
    const W = cv.width = cv.clientWidth * 2, H = cv.height = LANES.length * 64;
    const g = cv.getContext('2d'); g.clearRect(0, 0, W, H);
    const lh = H / LANES.length, L = 300;
    LANES.forEach(([k, label, lo, hi, col], li) => {
      const y0 = li * lh;
      g.fillStyle = li % 2 ? '#0b1220' : '#0f172a'; g.fillRect(0, y0, W, lh);
      g.fillStyle = '#94a3b8'; g.font = '22px sans-serif'; g.fillText(label, 10, y0 + 26);
      const v = response?.params?.[k]; if (!v) return;
      g.strokeStyle = col; g.lineWidth = 3; g.beginPath();
      v.forEach((x, i) => { const px = L + ((W - L) * i) / Math.max(1, v.length - 1), py = y0 + lh - 6 - ((Math.min(hi, Math.max(lo, x)) - lo) / (hi - lo)) * (lh - 12); i ? g.lineTo(px, py) : g.moveTo(px, py); });
      g.stroke();
    });
    if (response) { const x = L + (W - L) * frac; g.fillStyle = '#fbbf24'; g.fillRect(x - 1.5, 0, 3, H); }
  }, [response, frac]);
  return (
    <div data-testid="trajectory-chart">
      <canvas ref={ref} className="w-full rounded-xl" style={{ height: LANES.length * 32 }} />
      <p className="text-[10px] text-slate-500 mt-1">Le 8 traiettorie con cui il modello muove la bocca, come nel progetto Samuel: 7 previste dalla rete, l’intonazione misurata dalla voce.</p>
    </div>
  );
};
